import api from "./axios";

/**
 * Riders API Service
 */

export const listRiders = async (params = {}) => {
  const data = await api.get("/riders", { params });
  return data;
};

export const getRiderById = async (id) => {
  const data = await api.get(`/riders/${id}`);
  return data;
};

export const createRider = async (riderData) => {
  const data = await api.post("/riders", riderData);
  return data;
};

export const updateRider = async (id, riderData) => {
  const data = await api.put(`/riders/${id}`, riderData);
  return data;
};

export const deleteRider = async (id) => {
  const data = await api.delete(`/riders/${id}`);
  return data;
};

export const downloadTemplate = async () => {
  const response = await api.get("/riders/templates/download", {
    responseType: "blob",
  });
  return response;
};

export const exportRiders = async (filters = {}) => {
  const response = await api.get("/riders/export", {
    params: filters,
    responseType: "blob",
  });
  return response;
};

export const bulkUploadRiders = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  
  const data = await api.post("/riders/bulk-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const bulkDeleteRiders = async (ids) => {
  const data = await api.delete("/riders/bulk", {
    data: { ids },
  });
  return data;
};

export const forgotPasswordRider = async (id) => {
  const data = await api.post(`/riders/${id}/forgot-password`);
  return data;
};
